
  (() => {
    const initialize = (scope) => {
      scope.querySelectorAll('[data-mp-home-root]').forEach((root) => {
        if (root.dataset.mpHomeReady === 'true') return;
        root.dataset.mpHomeReady = 'true';

        const hero = root.querySelector('[data-mp-home-hero]');
        const slides = Array.from(root.querySelectorAll('[data-mp-home-slide]'));
        const tabs = Array.from(root.querySelectorAll('[data-mp-home-tab]'));
        const previousButton = root.querySelector('[data-mp-home-prev]');
        const nextButton = root.querySelector('[data-mp-home-next]');
        const storiesSection = root.querySelector('[data-mp-stories-section]');
        const storiesViewport = root.querySelector('[data-mp-stories-viewport]');
        const storiesPreviousButton = root.querySelector('[data-mp-stories-previous]');
        const storiesNextButton = root.querySelector('[data-mp-stories-next]');
        const storiesShowAllButton = root.querySelector('[data-mp-stories-show-all]');
        const storiesCards = Array.from(root.querySelectorAll('[data-mp-story-card]'));
        const storiesStatus = root.querySelector('[data-mp-stories-status]');
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        const autoplayDelay = 10000;
        const taxSelector = document.getElementById('mp-tax-selector');
        const taxNotes = Array.from(root.querySelectorAll('[data-mp-home-tax-note]'));
        const taxCards = Array.from(root.querySelectorAll('.mp-home-product-card'));
        let currentIndex = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));
        let autoplayTimer = null;
        let taxObserver = null;
        let pointerInside = false;
        let focusInside = false;
        const storiesBatchSize = 6;
        let storiesVisibleCount = storiesCards.filter((card) => !card.hidden).length;

        const syncTaxNotes = () => {
          if (!taxSelector || !taxNotes.length) return;
          const activeRoleButton = taxSelector.querySelector('[data-mp-tax-role][aria-pressed="true"]');
          const role = activeRoleButton?.dataset.mpTaxRole === 'business' ? 'business' : 'private';
          const country = (taxSelector.dataset.country || 'DE').toUpperCase();
          let noteText;

          if (country === 'DE' && role === 'private') {
            noteText = 'Privatkundenpreis · 0 % MwSt. nur bei begünstigten PV-Produkten; Checkout maßgeblich.';
          } else if (country === 'DE') {
            noteText = 'Geschäftskundenpreis · Bruttopreis inkl. 19 % MwSt.; Checkout maßgeblich.';
          } else if (role === 'private') {
            noteText = 'Privatkundenpreis · MwSt. des Lieferlands; Checkout maßgeblich.';
          } else {
            noteText = 'Geschäftskundenpreis · Nettopreis nach gültiger USt-IdNr.; Checkout maßgeblich.';
          }

          taxNotes.forEach((note) => {
            const card = note.closest('.mp-home-product-card');
            const priceIsSynced = card?.dataset.mpTaxCardRole === role;
            note.textContent = priceIsSynced
              ? noteText
              : `${role === 'business' ? 'Geschäftskunden' : 'Privatkunden'}-Auswahl · Steuer und Preis werden im Checkout bestätigt.`;
          });
        };

        if (taxSelector && taxNotes.length) {
          taxObserver = new MutationObserver(syncTaxNotes);
          taxObserver.observe(taxSelector, {
            attributes: true,
            attributeFilter: ['data-country'],
            subtree: true,
          });
          taxSelector.querySelectorAll('[data-mp-tax-role]').forEach((button) => {
            taxObserver.observe(button, {
              attributes: true,
              attributeFilter: ['aria-pressed'],
            });
          });
          taxCards.forEach((card) => {
            taxObserver.observe(card, {
              attributes: true,
              attributeFilter: ['data-mp-tax-card-role'],
            });
          });
          syncTaxNotes();
        }

        const stopAutoplay = () => {
          if (!autoplayTimer) return;
          window.clearInterval(autoplayTimer);
          autoplayTimer = null;
        };

        const startAutoplay = () => {
          stopAutoplay();
          if (slides.length < 2 || reducedMotion.matches || document.hidden || pointerInside || focusInside) return;
          autoplayTimer = window.setInterval(() => {
            activateSlide(currentIndex + 1);
          }, autoplayDelay);
        };

        const activateSlide = (index, focusTab = false, revealTab = false) => {
          if (!slides.length) return;
          const normalizedIndex = (index + slides.length) % slides.length;
          currentIndex = normalizedIndex;
          slides.forEach((slide, slideIndex) => {
            const active = slideIndex === normalizedIndex;
            slide.hidden = !active;
            slide.classList.toggle('is-active', active);
            slide.setAttribute('aria-hidden', active ? 'false' : 'true');
          });
          tabs.forEach((tab, tabIndex) => {
            const active = tabIndex === normalizedIndex;
            tab.classList.toggle('is-active', active);
            tab.setAttribute('aria-selected', active ? 'true' : 'false');
            tab.tabIndex = active ? 0 : -1;
          });
          if (focusTab && tabs[normalizedIndex]) tabs[normalizedIndex].focus();
          if (revealTab && tabs[normalizedIndex]) {
            tabs[normalizedIndex].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
          }
        };

        activateSlide(currentIndex);

        tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => {
            activateSlide(index, false, true);
            startAutoplay();
          });
          tab.addEventListener('keydown', (event) => {
            if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
            event.preventDefault();
            let nextIndex = index;
            if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
            if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
            if (event.key === 'Home') nextIndex = 0;
            if (event.key === 'End') nextIndex = tabs.length - 1;
            activateSlide(nextIndex, true, true);
            startAutoplay();
          });
        });

        if (previousButton) {
          previousButton.addEventListener('click', () => {
            activateSlide(currentIndex - 1);
            startAutoplay();
          });
        }

        if (nextButton) {
          nextButton.addEventListener('click', () => {
            activateSlide(currentIndex + 1);
            startAutoplay();
          });
        }

        const handleMouseEnter = () => {
          pointerInside = true;
          stopAutoplay();
        };
        const handleMouseLeave = () => {
          pointerInside = false;
          startAutoplay();
        };
        const handleFocusIn = () => {
          focusInside = true;
          stopAutoplay();
        };
        const handleFocusOut = (event) => {
          focusInside = hero ? hero.contains(event.relatedTarget) : false;
          if (!focusInside) startAutoplay();
        };
        const handleVisibilityChange = () => {
          if (document.hidden) stopAutoplay();
          else startAutoplay();
        };

        if (hero) {
          hero.addEventListener('mouseenter', handleMouseEnter);
          hero.addEventListener('mouseleave', handleMouseLeave);
          hero.addEventListener('focusin', handleFocusIn);
          hero.addEventListener('focusout', handleFocusOut);
        }
        document.addEventListener('visibilitychange', handleVisibilityChange);
        startAutoplay();

        const updateStoriesControls = () => {
          if (!storiesViewport) return;
          const maximumScroll = storiesViewport.scrollWidth - storiesViewport.clientWidth;
          storiesPreviousButton?.setAttribute('aria-disabled', storiesViewport.scrollLeft <= 2 ? 'true' : 'false');
          storiesNextButton?.setAttribute('aria-disabled', storiesViewport.scrollLeft >= maximumScroll - 2 ? 'true' : 'false');
        };

        const scrollStories = (direction) => {
          if (!storiesViewport) return;
          const firstCard = storiesViewport.querySelector('.mp-home-stories__card');
          const gap = Number.parseFloat(window.getComputedStyle(storiesViewport).columnGap) || 0;
          const distance = (firstCard?.getBoundingClientRect().width || storiesViewport.clientWidth) + gap;
          storiesViewport.scrollBy({
            left: distance * direction,
            behavior: reducedMotion.matches ? 'auto' : 'smooth',
          });
        };

        const handleStoriesPrevious = () => scrollStories(-1);
        const handleStoriesNext = () => scrollStories(1);
        const updateStoriesDisclosure = () => {
          if (!storiesShowAllButton) return;
          const allVisible = storiesVisibleCount >= storiesCards.length;
          storiesShowAllButton.hidden = allVisible || !storiesCards.length;
          storiesShowAllButton.setAttribute('aria-expanded', storiesVisibleCount > storiesBatchSize ? 'true' : 'false');
          if (storiesStatus) {
            storiesStatus.textContent = `${storiesVisibleCount} von ${storiesCards.length} Bildern sichtbar.`;
          }
        };

        const handleStoriesShowAll = () => {
          if (!storiesSection || !storiesShowAllButton || !storiesCards.length) return;
          storiesVisibleCount = Math.min(storiesVisibleCount + storiesBatchSize, storiesCards.length);
          storiesCards.slice(0, storiesVisibleCount).forEach((card) => {
            card.hidden = false;
          });
          storiesSection.classList.add('is-expanded');
          updateStoriesDisclosure();
        };

        if (storiesViewport) {
          storiesViewport.addEventListener('scroll', updateStoriesControls, { passive: true });
          storiesPreviousButton?.addEventListener('click', handleStoriesPrevious);
          storiesNextButton?.addEventListener('click', handleStoriesNext);
          storiesShowAllButton?.addEventListener('click', handleStoriesShowAll);
          updateStoriesControls();
          updateStoriesDisclosure();
        }

        root.mpHomeCleanup = () => {
          stopAutoplay();
          taxObserver?.disconnect();
          document.removeEventListener('visibilitychange', handleVisibilityChange);
          storiesViewport?.removeEventListener('scroll', updateStoriesControls);
          storiesPreviousButton?.removeEventListener('click', handleStoriesPrevious);
          storiesNextButton?.removeEventListener('click', handleStoriesNext);
          storiesShowAllButton?.removeEventListener('click', handleStoriesShowAll);
          if (hero) {
            hero.removeEventListener('mouseenter', handleMouseEnter);
            hero.removeEventListener('mouseleave', handleMouseLeave);
            hero.removeEventListener('focusin', handleFocusIn);
            hero.removeEventListener('focusout', handleFocusOut);
          }
        };

        const finder = root.querySelector('[data-mp-home-finder]');
        if (finder) {
          const steps = Array.from(finder.querySelectorAll('[data-mp-finder-step]'));
          const resultPanel = finder.querySelector('[data-mp-finder-result-panel]');
          const resultLink = finder.querySelector('[data-mp-finder-result-link]');
          const showStep = (stepNumber) => {
            steps.forEach((step) => {
              step.hidden = step.dataset.mpFinderStep !== String(stepNumber);
            });
            if (resultPanel) resultPanel.hidden = true;
          };

          finder.querySelectorAll('[data-mp-finder-next]').forEach((button) => {
            button.addEventListener('click', () => showStep(button.dataset.mpFinderNext));
          });

          finder.querySelectorAll('[data-mp-finder-result]').forEach((button) => {
            button.addEventListener('click', () => {
              steps.forEach((step) => { step.hidden = true; });
              if (resultLink && button.dataset.mpFinderResult) {
                resultLink.href = button.dataset.mpFinderResult;
                resultLink.firstChild.textContent = `${button.dataset.mpFinderLabel || 'Auswahl'} öffnen `;
              }
              if (resultPanel) resultPanel.hidden = false;
            });
          });

          const reset = finder.querySelector('[data-mp-finder-reset]');
          if (reset) reset.addEventListener('click', () => showStep(1));
        }
      });
    };

    initialize(document);
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll('[data-mp-home-root]').forEach((root) => {
        if (typeof root.mpHomeCleanup === 'function') root.mpHomeCleanup();
      });
    });
  })();
